export const COMPARE_EXPERIMENT_TAB_SEARCH_PARAM_PREFIX = 'compare-experiment-';
